import React from "react";
import { Button } from "flowbite-react";
import { Link, useLocation } from "react-router-dom";
import { useApplication } from "../../contexts/ApplicationContext";
import { canAccessRoute } from "../../utils/routeAccess";

// Portão de TELA por chave do cargo (`utils/routeAccess.js`). Quem digita o
// endereço de uma tela que o cargo não libera vê este aviso, em vez da tela
// vazia cheia de erro. O portão real continua sendo o servidor.
export const AccessDenied = () => (
  <div className="flex min-h-[420px] flex-col items-center justify-center gap-3 px-4 text-center">
    <h2 className="text-lg font-semibold text-slate-800">
      Você não tem acesso a esta página
    </h2>
    <p className="max-w-md text-sm text-slate-500">
      O seu papel não libera esta tela. Se precisar dela, peça a um
      administrador para ajustar as permissões.
    </p>
    <Button as={Link} to="/dashboard" color="gray" className="mt-2">
      Ir para a Visão Geral
    </Button>
  </div>
);

const RouteAccessGuard = ({ children }) => {
  const { access } = useApplication();
  const { pathname } = useLocation();

  if (!canAccessRoute(access, pathname)) return <AccessDenied />;
  return children;
};

export default RouteAccessGuard;
